import { render } from "./AboutView.vue?vue&type=template&id=06a3d1d8&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=06a3d1d8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a3d1d8"]])

export default __exports__